import { NgModule } from '@angular/core';
import { NgBootstrapModule } from './ng-bootstrap.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { bearerTokenInterceptor, sessionEndCheckInterceptor } from './interceptors/auth.interceptor';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire/compat'
import { environment } from '../../environments/environment';
import { AddAaTagsDirective } from '@app/directives/add-aa-tags.directive';
import { KeyboardActivationDirective } from '@app/directives/keyboard-activation.directive';
import {MatSelectModule} from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  imports: [
    NgBootstrapModule,
    AngularFireModule.initializeApp(environment.firebase),
    NgxExtendedPdfViewerModule,
    AngularFireModule.initializeApp(environment.firebase),
    MatSelectModule,
    MatDatepickerModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    NgBootstrapModule,
    RouterModule,
    NgxExtendedPdfViewerModule,
    AddAaTagsDirective,
    KeyboardActivationDirective,
    MatSelectModule,
    MatDatepickerModule
  ],
  declarations: [
    AddAaTagsDirective,
    KeyboardActivationDirective
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptors([bearerTokenInterceptor, sessionEndCheckInterceptor])),
    provideFirebaseApp(() => initializeApp(environment.firebase),),
    provideAuth(() => getAuth()),
  ],
})

export class SharedModule { }
